module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GD - Grenada.2ea3b86c.svg";